import {abilityCheck, resolve} from "@/helpers/Utils";

export default {
  install(Vue) {
    const can = function (rules) {
      const { user } = this.$store.state.user;
      let params = resolve(user, 'abilities', null);
      if (!params) params = resolve(user, 'role')
      return abilityCheck(params, rules);
    };

    Vue.mixin({
      methods: {
        can,
      }
    })
    Vue.prototype.$can = can;
  }
}
